var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_23801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95893 12.9847L0.828125 18.0565L5.48024 16.8237L15.063 6.37654C16.0358 5.31596 16.0358 3.59819 15.063 2.53762C14.0902 1.47704 12.5145 1.47704 11.5417 2.53762L1.95893 12.9847Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3672 5.01172L13.2879 7.10568",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26562 16.125L2.60014 17.589",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 18.0566H15.794",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_23801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6295,
    height: 18.1295,
    fill: "white",
    transform: "translate(0 0.833984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPencil);
export default __webpack_public_path__ + "static/media/icon-edit-pencil.deffd3d0e9993ef4c92298ef5640a1eb.svg";
export { ForwardRef as ReactComponent };